import { IsDate, IsString } from 'class-validator';

export class EntityVm {
  @IsString()
  id: string;

  @IsDate()
  createdAt: Date;

  @IsDate()
  updatedAt: Date;
}
